import React, { useContext, useEffect } from "react";
import Heading from "../core/Heading";
import { Box, IconButton } from "@mui/material";
import { FormDataContext } from "../contexts/FormContext";
import { displayNotification } from "helpers";
import { useTranslation } from "react-i18next";
import { MISSION_EXPERT_RESPONSE_STATUSES } from "modules/pvs_activities/constants";
import ManagePeerReviewerModal from "./modals/ManagePeerReviewerModal";
import { FaTrash } from "react-icons/fa";
import {
    dFormApi,
    useGetExpertsFromMovementQuery,
    useLazyGetExpertsFromMovementQuery,
} from "modules/pvs_activities/redux/service/dForm";
import { useDeleteMissionExpertDataMutation } from "modules/pvs_activities/redux/service/missionExpert";
import { useDispatch } from "react-redux";

const defaultProps = {
    id: "",
    element: {},
    isReadOnly: false,
};

const PeerReviewerSelection = (rawProps) => {
    const props = { ...defaultProps, ...rawProps };

    const { t } = useTranslation();
    const formDataContext = useContext(FormDataContext);
    const dispatch = useDispatch();

    const dataRes = useGetExpertsFromMovementQuery(
        {
            movementId: formDataContext.movementId,
            params: {
                selectExpertPeereviewer: 2,
            },
        },
        { skip: formDataContext.mode === "preview" }
    );
    const [deleteTrigger, deleteRes] = useDeleteMissionExpertDataMutation();

    useEffect(() => {
        if (dataRes.isError) {
            displayNotification("error", t("-1", "Error loading peer reviewers"));
            console.error({ e: dataRes.error });
        }
    }, [dataRes]);

    useEffect(() => {
        if (deleteRes.isError) {
            displayNotification("error", t("-1", "Error deleting peer reviewer"));
            console.error({ e: deleteRes.error });
        }
        if (deleteRes.isSuccess) {
            displayNotification("success", t("-1", "Successfully deleted peer reviewer"));
            dispatch(dFormApi.util.invalidateTags(["ExpertsFromMovement"]));
        }
    }, [deleteRes]);

    const handleDelete = (exp) => {
        if (window.confirm("You are about to delete an expert. Are you sure?") && exp.response_status == 0) {
            deleteTrigger(exp.id);
        }
    };

    return (
        <>
            <Box sx={{ display: "flex" }} className="mb-1">
                <Heading label="Peer Reviewer List" className="my-auto" />
                {props.isReadOnly === false && (
                    <Box sx={{ ml: "auto", my: "auto" }}>
                        <ManagePeerReviewerModal
                            id={props.id}
                            element={props.element}
                            missionId={formDataContext.missionId}
                        />
                    </Box>
                )}
            </Box>
            <table className="table table-bordered">
                <thead className="bg-primary text-white">
                    <tr>
                        <th width="50px" className="text-center">
                            #
                        </th>
                        <th>Expert Name</th>
                        <th className="text-center">Position</th>
                        <th className="text-center" width="200px">
                            Acceptance Status
                        </th>
                        <th className="text-center" width="100px">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {(dataRes.isSuccess && dataRes.data.length === 0) || dataRes.isUninitialized ? (
                        <tr>
                            <td className="text-center" colSpan={5}>
                                No Data Found
                            </td>
                        </tr>
                    ) : dataRes.isError ? (
                        <tr>
                            <td className="text-center" colSpan={5}>
                                Error loading data!
                            </td>
                        </tr>
                    ) : dataRes.isLoading ? (
                        <tr>
                            <td className="text-center" colSpan={5}>
                                Loading...
                            </td>
                        </tr>
                    ) : dataRes.isSuccess ? (
                        dataRes.data.map((r, k) => (
                            <tr key={r.id}>
                                <td className="text-center">{k + 1}</td>
                                <td>{r.expert_name}</td>
                                <td className="text-center">{r.position_name}</td>
                                <td className="text-center">
                                    {MISSION_EXPERT_RESPONSE_STATUSES[r.response_status] ?? "-"}
                                </td>
                                <td className="text-center">
                                    <IconButton
                                        color="error"
                                        onClick={() => handleDelete(r)}
                                        disabled={r.response_status !== 0}
                                        className="my-auto"
                                        size="small"
                                    >
                                        <FaTrash />
                                    </IconButton>
                                </td>
                            </tr>
                        ))
                    ) : null}
                </tbody>
            </table>
        </>
    );
};

export default PeerReviewerSelection;
